export default [
  '/landing/ask-the-experts/',
  '/landing/safe-driver/',
  '/landing/business-insurance/',
  '/landing/store-cary-pp/',
  '/landing/easy-to-insure/',
  '/landing/viking/',
  '/landing/car-care-helping-every-day/',
];
